// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import { RefundFieldsFragmentDoc } from './refunds.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AttributionFieldsFragment = { __typename?: 'Attribution', internal_source?: Types.BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: Types.BookingInternalSourceEntityType | null };

export type BadgeFieldsFragment = { __typename?: 'Badge', id: string, name: string, icon_url: string, created_at: number, updated_at: number };

export type PaymentCustomerFieldsFragment = { __typename?: 'Payment', user?: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null, phone?: string | null } | null, group_pay_member?: { __typename?: 'GroupPayMember', id: string, email: string, name: string, phone?: string | null } | null, customer?: { __typename?: 'PaymentCustomer', name?: string | null, email?: string | null, phone?: string | null } | null };

export type TripItineraryItemFieldsFragment = { __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: Types.TripItineraryItemType };

export type TripItineraryFieldsFragment = { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: Types.TripItineraryItemType }> };

export type EntityListCountFieldsFragment = { __typename?: 'Counts', count: number, name: string, key: string };

export type EntityListCountsFieldsFragment = { __typename?: 'CountsResponse', total: number, counts: Array<{ __typename?: 'Counts', count: number, name: string, key: string }> };

export type EntityListCountsQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
  key: Types.EntityListCountsKey;
}>;


export type EntityListCountsQuery = { __typename?: 'Query', entityListCounts: { __typename?: 'CountsResponse', total: number, counts: Array<{ __typename?: 'Counts', count: number, name: string, key: string }> } };

export type FormFieldsFragment = { __typename?: 'Form', id: string, name: string, description?: string | null, outfitter_id: string, external_form_url?: string | null, is_published?: boolean | null, is_required?: boolean | null, should_create_lead_from_submission?: boolean | null, is_e_signature_required?: boolean | null, submissions_count?: number | null, success_redirect_url?: string | null, url?: string | null, created_by?: string | null, created_at: number, updated_at: number, link_to_booking_configs?: { __typename?: 'LinkToBookingConfigs', listings?: Array<string> | null, pricing_packages?: Array<string> | null, has_to_be_filled_per_member?: boolean | null } | null, form_inputs?: Array<{ __typename?: 'FormInput', id: string, input_type: Types.FormInputType, title: string, options?: Array<string> | null, placeholder?: string | null, is_required: boolean, additional_notes?: string | null, should_allow_pricing_package_selection?: boolean | null, order?: number | null }> | null };

export type FormInputFieldsFragment = { __typename?: 'FormInput', id: string, input_type: Types.FormInputType, title: string, options?: Array<string> | null, placeholder?: string | null, is_required: boolean, additional_notes?: string | null, should_allow_pricing_package_selection?: boolean | null, order?: number | null };

export type TripInsuranceFieldsFragment = { __typename?: 'BookingTripInsurance', is_accepted?: boolean | null, insurance_policy_number?: string | null, insurance_quote_id: string, errors?: Array<{ __typename?: 'TripInsuranceError', message: string, date: number }> | null };

export type BookingPaymentFieldsFragment = { __typename?: 'Payment', id: string, date: number, value: number, status: Types.PaymentStatus, mb_amount: number, outfitter_amount: number, outfitter_fee: number, booking_fee: number, processing_fee: number, sales_tax: number, invoice_id?: string | null, is_offline?: boolean | null, external_payment_type?: Types.ExternalPaymentType | null, external_payment_reference_id?: string | null, transfer_date?: number | null, is_refund_needed?: boolean | null, is_payment_method_unverified?: boolean | null, refund_needed_note?: string | null, was_refunded?: boolean | null, errors: Array<{ __typename?: 'PaymentError', message: string }> };

export type BookingPaymentWithRefundsFieldsFragment = { __typename?: 'Payment', id: string, date: number, value: number, status: Types.PaymentStatus, mb_amount: number, outfitter_amount: number, outfitter_fee: number, booking_fee: number, processing_fee: number, sales_tax: number, invoice_id?: string | null, is_offline?: boolean | null, external_payment_type?: Types.ExternalPaymentType | null, external_payment_reference_id?: string | null, transfer_date?: number | null, is_refund_needed?: boolean | null, is_payment_method_unverified?: boolean | null, refund_needed_note?: string | null, was_refunded?: boolean | null, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: Types.RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: Types.StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }>, errors: Array<{ __typename?: 'PaymentError', message: string }> };

export type PaymentRetryFieldsFragment = { __typename?: 'PaymentRetry', id: string, note?: string | null, date: number };

export type BookingPaymentWithStripeUrlAndRefundsFieldsFragment = { __typename?: 'Payment', total?: number | null, intent_id?: string | null, note?: string | null, payment_method_id?: string | null, is_ach?: boolean | null, is_additional_booking_payment?: boolean | null, payment_url?: string | null, id: string, date: number, value: number, status: Types.PaymentStatus, mb_amount: number, outfitter_amount: number, outfitter_fee: number, booking_fee: number, processing_fee: number, sales_tax: number, invoice_id?: string | null, is_offline?: boolean | null, external_payment_type?: Types.ExternalPaymentType | null, external_payment_reference_id?: string | null, transfer_date?: number | null, is_refund_needed?: boolean | null, is_payment_method_unverified?: boolean | null, refund_needed_note?: string | null, was_refunded?: boolean | null, retries?: Array<{ __typename?: 'PaymentRetry', id: string, note?: string | null, date: number }> | null, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: Types.RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: Types.StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }>, user?: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null, phone?: string | null } | null, group_pay_member?: { __typename?: 'GroupPayMember', id: string, email: string, name: string, phone?: string | null } | null, customer?: { __typename?: 'PaymentCustomer', name?: string | null, email?: string | null, phone?: string | null } | null, errors: Array<{ __typename?: 'PaymentError', message: string }> };

export const AttributionFieldsFragmentDoc = gql`
    fragment AttributionFields on Attribution {
  internal_source
  internal_source_entity_id
  internal_source_entity_type
}
    `;
export const BadgeFieldsFragmentDoc = gql`
    fragment BadgeFields on Badge {
  id
  name
  icon_url
  created_at
  updated_at
}
    `;
export const TripItineraryItemFieldsFragmentDoc = gql`
    fragment TripItineraryItemFields on TripItineraryItem {
  title
  label
  helper_text
  timestamp
  type
}
    `;
export const TripItineraryFieldsFragmentDoc = gql`
    fragment TripItineraryFields on TripItinerary {
  title
  label
  items {
    ...TripItineraryItemFields
  }
}
    ${TripItineraryItemFieldsFragmentDoc}`;
export const EntityListCountFieldsFragmentDoc = gql`
    fragment EntityListCountFields on Counts {
  count
  name
  key
}
    `;
export const EntityListCountsFieldsFragmentDoc = gql`
    fragment EntityListCountsFields on CountsResponse {
  counts {
    ...EntityListCountFields
  }
  total
}
    ${EntityListCountFieldsFragmentDoc}`;
export const FormInputFieldsFragmentDoc = gql`
    fragment FormInputFields on FormInput {
  id
  input_type
  title
  options
  placeholder
  is_required
  additional_notes
  should_allow_pricing_package_selection
  order
}
    `;
export const FormFieldsFragmentDoc = gql`
    fragment FormFields on Form {
  id
  name
  description
  outfitter_id
  external_form_url
  is_published
  is_required
  should_create_lead_from_submission
  link_to_booking_configs {
    listings
    pricing_packages
    has_to_be_filled_per_member
  }
  form_inputs {
    ...FormInputFields
  }
  is_e_signature_required
  submissions_count
  should_create_lead_from_submission
  success_redirect_url
  url
  created_by
  created_at
  updated_at
}
    ${FormInputFieldsFragmentDoc}`;
export const TripInsuranceFieldsFragmentDoc = gql`
    fragment TripInsuranceFields on BookingTripInsurance {
  is_accepted
  insurance_policy_number
  insurance_quote_id
  errors {
    message
    date
  }
}
    `;
export const BookingPaymentFieldsFragmentDoc = gql`
    fragment BookingPaymentFields on Payment {
  id
  date
  value
  status
  mb_amount
  outfitter_amount
  outfitter_fee
  booking_fee
  processing_fee
  sales_tax
  invoice_id
  is_offline
  external_payment_type
  external_payment_reference_id
  transfer_date
  is_refund_needed
  is_payment_method_unverified
  refund_needed_note
  was_refunded
  errors {
    message
  }
}
    `;
export const BookingPaymentWithRefundsFieldsFragmentDoc = gql`
    fragment BookingPaymentWithRefundsFields on Payment {
  ...BookingPaymentFields
  refunds {
    ...RefundFields
  }
}
    ${BookingPaymentFieldsFragmentDoc}
${RefundFieldsFragmentDoc}`;
export const PaymentRetryFieldsFragmentDoc = gql`
    fragment PaymentRetryFields on PaymentRetry {
  id
  note
  date
}
    `;
export const PaymentCustomerFieldsFragmentDoc = gql`
    fragment PaymentCustomerFields on Payment {
  user {
    id
    email
    first_name
    last_name
    phone
  }
  group_pay_member {
    id
    email
    name
    phone
  }
  customer {
    name
    email
    phone
  }
}
    `;
export const BookingPaymentWithStripeUrlAndRefundsFieldsFragmentDoc = gql`
    fragment BookingPaymentWithStripeUrlAndRefundsFields on Payment {
  ...BookingPaymentWithRefundsFields
  total
  intent_id
  note
  retries {
    ...PaymentRetryFields
  }
  payment_method_id
  is_ach
  is_additional_booking_payment
  payment_url
  ...PaymentCustomerFields
}
    ${BookingPaymentWithRefundsFieldsFragmentDoc}
${PaymentRetryFieldsFragmentDoc}
${PaymentCustomerFieldsFragmentDoc}`;
export const EntityListCountsDocument = gql`
    query entityListCounts($outfitterId: ID!, $key: EntityListCountsKey!) {
  entityListCounts(outfitterId: $outfitterId, key: $key) {
    ...EntityListCountsFields
  }
}
    ${EntityListCountsFieldsFragmentDoc}`;

/**
 * __useEntityListCountsQuery__
 *
 * To run a query within a React component, call `useEntityListCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityListCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityListCountsQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useEntityListCountsQuery(baseOptions: Apollo.QueryHookOptions<EntityListCountsQuery, EntityListCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityListCountsQuery, EntityListCountsQueryVariables>(EntityListCountsDocument, options);
      }
export function useEntityListCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityListCountsQuery, EntityListCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityListCountsQuery, EntityListCountsQueryVariables>(EntityListCountsDocument, options);
        }
export type EntityListCountsQueryHookResult = ReturnType<typeof useEntityListCountsQuery>;
export type EntityListCountsLazyQueryHookResult = ReturnType<typeof useEntityListCountsLazyQuery>;
export type EntityListCountsQueryResult = Apollo.QueryResult<EntityListCountsQuery, EntityListCountsQueryVariables>;